import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs, validationSchema } from '@/entities/Transactions/TransactionsFormInputs'

const Transactions = {
	Plural: 'Coins Transactions',
	Single: 'Coins Transaction',
	Inputs: Inputs,

	ValidationSchema: validationSchema,
	Relationships: [
		{
			name: 'user',
			endpoint: Endpoints.USERS_FOR_FILTERS,
			dataMapping: (response) => {
				return response.map(u => ({
					...u,
					name: u.nickName,
				}));
				
			},
		}
	],
	SaveCallBack: (id) => {
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Transactions;
